import { green } from '@ant-design/colors';
import { CheckCircleOutlined } from "@ant-design/icons";
import { notification, Typography } from "antd";
import { ContainerComponent } from "../../../../components";

import { UseCaseFormPartial } from "../../../../partials/use-case-form.partial";
import { CatalogRoute } from '../../../catalog';
import { useNavigate } from "react-router-dom";

export const CreateUseCaseView = () => {
  const [api, contextHolder] = notification.useNotification();
  const navigate = useNavigate();
  return (
    <ContainerComponent>
      {contextHolder}
      <ContainerComponent
        style={{
          backgroundColor: "#ffffff",
          padding: 16,
          borderRadius: "16px 16px 0 0",
          boxShadow: "0 4px 15px rgba(0, 0, 0, 0.0)",
        }}
      >
        <Typography.Title level={3} style={{ margin: 0, alignSelf: "start", color: "var(--color-primary)" }}>
          Agregar Nuevo Caso de Uso
        </Typography.Title>
        <Typography.Text style={{ alignSelf: "start", marginBottom: 16, marginTop: 16, color: "#969696" }}>
          Complete el formulario para agregar un nuevo caso de uso al catálogo.
        </Typography.Text>
      </ContainerComponent>
      
      <UseCaseFormPartial
        url={"/usecase"}
        method={"POST"}
        onSaved={(result) => {
          api.open({
            message: <span style={{ color: "#ffffff" }}>¡Éxito!</span>,
            description: (
              <span style={{ color: "#ffffff" }}>
                El caso de uso se guardó correctamente.
              </span>
            ),
            icon: (<CheckCircleOutlined />),
            style: {
              backgroundColor: green[6],
              border: "1px solid #237804",
              color: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
              padding: "16px",
            },
            duration: 3, // Duración de la notificación en segundos
          });

          setTimeout(() => {
            navigate(`${CatalogRoute}?filter=industries`);
          }, 4000);
        }}
      />
    </ContainerComponent>
  );
};
